import tw from 'twin.macro';
import React from 'react';

const Paragraph = ({ children, size }) => (
  <p css={[tw`text-sm text-gray-500 my-1`, size === 'medium' && tw`text-lg`]}>
    {children}
  </p>
);
export default Paragraph;
